/* eslint-disable no-console,no-undef, camelcase */
/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getActiveEvents } from "../../../redux/actions";
import { LayoutNew } from "../../EventDetails/styles";
import { BuddyTabContainer, BuddyTab } from "../../PeopleHomeV2/styles";
//import HoverButton from "../../common/HoverButton";
import { CompletedChallengeWrapper } from "../styles";
import { WolibaCard, WolibaButton, NoEvents } from "../CompanyLiveEvents/styles";
import AboutTheEventModal from "../AboutTheEventModal";
import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
import Waiting from "../../Waiting";
import { ImageUrl } from "../../../utils/constants";
import moment from "moment";
import { convertDateInTimezone, convertMonthFromDate } from "../../../utils/methods";
import LazyImage from "../../common/LazyImage/LazyImage";
import {CoachCard} from '../SingleEventV2/styles';
//import { InfoIconV2 } from "../../../utils/icons";
import { ToolTipNew } from "../../AdminTeamCreation/styles";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { NewBackArrowIconForEvents } from "../../../utils/icons";
import { ReservedButton } from "../../../components/MainEvents/styles"
import { CommonButtonBorder } from "../../common/commonStyles";

class LiveEventsMain extends Component {
  constructor() {
    super();
    this.state = {
      pageNumber: 1,
      tabValue: 1,
      showAboutEventModal: false,
      eventCalendarId: null,
    };
  }

  componentDidMount() {
    const { getActiveEvents } = this.props;
    const { pageNumber } = this.state;
    getActiveEvents(pageNumber);
  }

  updateTabStatus = () => {
    this.props.history.push("/events/schedule")
  };

  toggleModalV2 = (event) => {
    if(event){
      event.stopPropagation();
    }
    this.setState((prev) => ({
      showAboutEventModal: !prev.showAboutEventModal,
    }));
  };

  toggleModal = (id, event) => {
    event.stopPropagation();
    this.setState((prev) => ({
      showAboutEventModal: !prev.showAboutEventModal,
      eventCalendarId: id,
    }));
  };

  backButton = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
      <path d="M7.11474 16C7.20246 16.0005 7.28942 15.9837 7.37063 15.9505C7.45184 15.9173 7.52571 15.8685 7.58799 15.8067C7.65047 15.7447 7.70005 15.671 7.73389 15.5898C7.76773 15.5086 7.78516 15.4214 7.78516 15.3334C7.78516 15.2454 7.76773 15.1583 7.73389 15.0771C7.70005 14.9959 7.65047 14.9221 7.58799 14.8602L2.14226 9.41445C1.76779 9.03951 1.55745 8.53127 1.55745 8.00136C1.55745 7.47145 1.76779 6.9632 2.14226 6.58827L7.58799 1.14253C7.71351 1.01702 7.78402 0.846784 7.78402 0.66928C7.78402 0.491776 7.71351 0.321542 7.58799 0.196028C7.46248 0.0705132 7.29224 0 7.11474 0C6.93723 0 6.767 0.0705132 6.64149 0.196028L1.19575 5.64176C0.885384 5.95135 0.639141 6.31912 0.471127 6.72402C0.303112 7.12892 0.216628 7.56298 0.216628 8.00136C0.216628 8.43973 0.303112 8.8738 0.471127 9.2787C0.639141 9.68359 0.885384 10.0514 1.19575 10.361L6.64149 15.8067C6.70377 15.8685 6.77763 15.9173 6.85885 15.9505C6.94006 15.9837 7.02702 16.0005 7.11474 16Z" fill="#F37A65"/>
    </svg>
  );

  liveEventsAPICall = (pageNumber) => {
    this.props.getActiveEvents(pageNumber);
  };
  

  headerView = () => {
    const { tabValue } = this.state;
    const popover = (value) => (
      <Popover
        id="popover-basic"
        style={{
          width: "auto",
          padding: "9px 14px",
          background: "#FFFFFF",
          border: "1px solid #005c87",
          boxShadow: "0px 13px 28px rgba(0, 0, 0, 0.3)",
          borderRadius: "6px",
        }}
      >
        <div
          style={{
            fontFamily: "Rubik",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "20px",
            color: "#005c87",
            textAlign: "center",
          }}
        >
          {this.props.t(value)}
        </div>
      </Popover>
    );
    return (
      <BuddyTabContainer marginBottom="25px">
        {/* <div className="backButton">
          <HoverButton
            title={this.props.t("Back")}
            svgPath={this.backButton()}
            onClick={() => this.props.history.push("/events")}
            width={"25"}
            height={"25"}
            // activeColor={"#007AB1"}
            fillOpacity={"1"}
            marginLeft={"0px"}
          />
        </div>   */}
        <ToolTipNew
          margin={"auto 0px auto 15px"}
          height="40px"
          width="40px"
        >
          <OverlayTrigger placement="bottom" overlay={popover(this.props.t("Back"))}>
            <div
              className='toolTip'
              onClick={() => this.props.history.push(`/events`)}
              style={{ background: "none" }} 
            >
              <NewBackArrowIconForEvents/> 
            </div>
          </OverlayTrigger>
        </ToolTipNew>
        <BuddyTab
          width
          padding
          active={tabValue === 2}
          onClick={() => this.updateTabStatus()}
          margin={"10px 0px"}
        >
          {" "}
          {this.props.t("My Schedule")}
        </BuddyTab>
        <BuddyTab
          width
          padding
          active={tabValue === 1}
          // style={{color:'#005c87'}}
          margin={"10px 0px 10px 10px"}
        >
          {this.props.t("Live events")}
        </BuddyTab>
        
      </BuddyTabContainer>
    );
  };

  onScroll = (e, events) => {
    const { pageNumber } = this.state;
    const { totalCount } = this.props;
    const bottom =
      Math.round(e.target.scrollHeight - parseInt(e.target.scrollTop,10)) ===
        Math.round(e.target.clientHeight + 1) ||
      Math.round(e.target.scrollHeight - parseInt(e.target.scrollTop,10) + 1) ===
        Math.round(e.target.clientHeight + 1);
    if (events.length < totalCount) {
      if (bottom) {
        this.setState(
          {
            pageNumber: pageNumber + 1,
          },
          () => {
            this.liveEventsAPICall(this.state.pageNumber);
          }
        );
      }
    }
  };

  handleWolibaLive = (id, attending, event) => {
    event.stopPropagation();
    this.props.attendEvent(id, attending, 1);
  };

  sortDataByDate = (data) => {
    const sortedData = data.sort((a, b) => (
      new Date(a.start_date) - new Date(b.start_date)
    ));

    return sortedData;
  };

  redirection = (route) => {
    this.props.history.push(route)
  }

  render() {
    const { showAboutEventModal, eventCalendarId, tabValue } = this.state;
    const { activeEvents, role } = this.props;
    if (!activeEvents || isUndefined(activeEvents) || isNull(activeEvents)) {
      return <Waiting />;
    }
    let activeLiveEvents=activeEvents && activeEvents.length?this.sortDataByDate(activeEvents):[];
    return (
      <LayoutNew>
        <div className="containerDiv">  
          {this.headerView()}
          <CompletedChallengeWrapper
            // overflow
            // height
            // onScroll={(e) => this.onScroll(e, activeEvents)}
          >
            {tabValue === 1 && activeLiveEvents && activeLiveEvents.length
              ? activeLiveEvents.map((data, index) => (
                <WolibaCard
                  width="calc((100% - 50px) / 3)"
                  margin={(index + 1) % 3 === 0 ? "0 0 25px 0" : "0 25px 25px 0"}
                  key={index}
                >
                  {/* <div className="eventLabel">
                    <div className="label">{data.is_global_event=="1"?this.props.t("Woliba Live"):this.props.t("Company Live")}</div>
                  </div> */}
                  {data?.coach_details?<CoachCard onClick={() =>this.props.history.push(`/events/${data.id}`)}>
                    <div className='cardWrapper'>
                      <div className='imagecard'>
                        <img src={`${ImageUrl}/${data?.coach_details?.image}`} />
                      </div>
                      <div className='coach-details'>
                        <div className='title'>{data?.coach_details?.name}</div>
                        <div className='info'>{data?.coach_details?.education}</div>
                      </div>
                    </div>
                  </CoachCard>:
                    <div
                      className="imageCard"
                      onClick={() =>
                        this.props.history.push(`/events/${data.id}`)
                      }
                    >
                      <img src={`${ImageUrl}/${data.image}`} alt="category" />
                    </div>}
                  <div className="bg-opacity"> </div>
                  <div className="detailsCard">
                    <div className="titleCard">
                      <div className="title">{this.props.t(data.title)}</div>
                      {/* <div className="icon">
                        <span onClick={(event) =>this.toggleModal(data.id, event)} style={{cursor: "pointer"}} >{InfoIconV2()}</span>
                      </div> */}
                    </div>
                    <div className="time">
                      {convertMonthFromDate(moment(convertDateInTimezone(data && data.start_date)._d).format("MMM DD, hh:mm a"), this.props)}{" "}({data.abbreviation}) |{" "}{data.event_location ? this.props.t("Onsite") : this.props.t("Virtual")}
                    </div>
                    {
                      moment(convertDateInTimezone(data.start_date)._d) < new Date() &&
                        data.is_attending === 1 &&
                        data.event_location === null && data.event_type != "theme" ? (
                          <a
                            href={data.event_encrypted_link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ width: "100%", textDecoration: "none" }}
                          >
                            <ReservedButton
                              active={true}
                              style={{
                                width: "100%",
                                margin:
                                  data && data.attendees_list && data.attendees_list.length < 3
                                    ? "auto 27px auto auto"
                                    : "auto 15px auto auto",
                                justifyContent: "center",
                                boxShadow: "0px 4px 12px rgba(105, 194, 255, 0.5)",
                                border: "1px solid #F37A65",
                              }}
                            >
                              {this.props.t("Join Event")}
                            </ReservedButton>
                          </a>
                        ) :data.event_type === "theme" ? <CommonButtonBorder  onClick={()=> this.props.history.push(`/events/${data.id}`)}  height={'40px'}width={'100%'} margin={'0px'}>View Event </CommonButtonBorder> : (
                          <WolibaButton
                            onClick={(event) =>
                              this.handleWolibaLive(data.id, data.is_attending, event)
                            }
                            background={data.is_attending && "white"}
                            margin={
                              data && data.attendees_list && data.attendees_list.length < 3
                                ? "auto 27px auto auto"
                                : "auto 15px auto auto"
                            }
                            style={{ justifyContent: "center" }}
                            // boxShadow={
                            //   !data.is_attending && "0px 4px 12px rgba(105, 194, 255, 0.5)"
                            // }
                            color={data.is_attending && "#005c87"}
                            border={data.is_attending && "1px solid #F37A65"}
                          >
                            <div className="title">
                              {!data.is_attending
                                ? this.props.t("Reserve Spot")
                                : this.props.t("Cancel Reservation")}
                            </div>
                          </WolibaButton>
                        )
                    }

                  </div>
                  {eventCalendarId === data.id && showAboutEventModal && (
                    <AboutTheEventModal
                      showModal={showAboutEventModal}
                      onHide={this.toggleModalV2}
                      title={(data && data.title) || ""}
                      body={(data && data.body) || ""}
                    />
                  )}
                </WolibaCard>)): 
              <NoEvents>
                <LazyImage div={"imageCard"} src={`${ImageUrl}${"/images/Events/NoEvents.png"}`} alt="No-Events"/>
                {
                  role==="WELLNESS_ADMIN"||role==="ADMIN"?
                    <div className="text" style={{color:"#005c87",fontFamily:"rubik"}}>
                      {this.props.t("You have no upcoming live events.")}
                    </div>:
                    <div className="text" style={{color:"#005c87",fontFamily:"rubik"}}>
                      {this.props.t("There is no Live Event Created. Soon we will add a few events")} {this.props.t("till then See are OnDemand Classes")}
                    </div>}
                <div className="buttonContainer">
                  <div className="buttons">
                    <WolibaButton>
                      {role==="WELLNESS_ADMIN"||role==="ADMIN"?
                        <div className="button-title" onClick={() =>this.redirection("/company/events/create")}>
                          {this.props.t("Create Event")}
                        </div>:
                        <div className="button-title" onClick={() =>this.redirection("/events")}>
                          {this.props.t("Go to Events Dashboard")}
                        </div>
                      }
                    </WolibaButton>
                  </div>
                </div>
              </NoEvents>
            }
          </CompletedChallengeWrapper>
        </div>
      </LayoutNew>
    );
  }
}

LiveEventsMain.propTypes = {
  history: PropTypes.object.isRequired,
  getActiveEvents: PropTypes.func,
  activeEvents: PropTypes.array,
  totalCount: PropTypes.number.isRequired,
  attendEvent: PropTypes.func,
  role: PropTypes.string,
  t: PropTypes.func
};

const mapStateToProps = (state) => ({
  activeEvents: state.events.activeEvents,
});

const mapDispatchToProps = (dispatch) => ({
  getActiveEvents: (pageNo) => dispatch(getActiveEvents(pageNo)),
});

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(LiveEventsMain));
